import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appEnterObserver]'
})
export class EnterObserverDirective {
  
  @Output() enterPressed = new EventEmitter<KeyboardEvent>();
  
  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.enterPressed.emit(event);
    }
  }
}
